import React from 'react';
import { ACH, AmexCard, DiscoverCard, MasterCard, VisaCard } from 'ui-kit/components/card/PaymentCard';

interface CardBrandIconProps {
  ePayType: string;
}

const CardBrandIcon: React.FC<CardBrandIconProps> = ({ ePayType }) => {
  switch (ePayType?.toUpperCase()) {
    case 'VISA':
      return <VisaCard />;
    case 'MASTERCARD':
      return <MasterCard />;
    case 'ACH':
      return <ACH />;
    case 'AMERICANEXPRESS':
      return <AmexCard />;
    case 'DISCOVER':
      return <DiscoverCard />;
    default:
      return null;
  }
};

export default CardBrandIcon;
